import React, { FC, useState, useEffect } from 'react';
import './style.scss';

interface Props {
  styleDef?: React.CSSProperties;
}

const RequiredLabel: FC<Props> = ({ styleDef }) => {
  return (
    <div className="_required_label_def_div" style={styleDef}>
      <div className="_text">필수</div>
    </div>
  );
};

export default RequiredLabel;
